import React from 'react';

import NavBar from '@components/Navbar';
import { useClient } from '@lib/hooks'
import useIsomorphicLayoutEffect from '@lib/hooks/useIsomorphicLayoutEffect'

import styles from './navbar.module.less';

export default function T () {
  // const [visable, setVisable] = useState(true)
  const isPc = useClient()
  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handBackgroundColor)
    return () => window.removeEventListener('scroll', handBackgroundColor)
  }, [isPc])
  const handBackgroundColor = (a) => {
    // const num = document.documentElement.scrollTop
    const opcity = document.documentElement.scrollTop /
      (document.getElementById('__next').clientHeight -
        document.body.clientHeight)
    if (isPc) {
      const webnavbarDom =
        document.querySelector('div[data-name=kiki-navabar-web]')
      webnavbarDom.style.background = `rgba(20, 20, 32, ${opcity})`
    } else {
      // const opcity = num > 54 ? 1 : num / 54
      const h5navbarDom =
        document.querySelector('div[data-name=kiki-navabar-h5]')
      h5navbarDom.style.background = `rgba(20, 20, 32, ${opcity})`
    }
  }
  return (
    <div className={styles.navabar}>
      <NavBar type={'2'} theme={'dark'}/>
    </div>
  )
}
